import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/home-2";
import Privacy from "./pages/privacy";
import Voorwaarden from "./pages/voorwaarden";
import NoPage from "./pages/NoPage";

// ART-WER one-page site. The maroof template's other demo pages remain on disk
// (design system untouched) but are not routed — only the ArtWer home renders.
export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route index element={<Home />} />
        <Route path="privacy" element={<Privacy />} />
        <Route path="voorwaarden" element={<Voorwaarden />} />
        <Route path="*" element={<NoPage />} />
      </Routes>
    </BrowserRouter>
  );
}
